// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dd82b526","455":"4898e0d7","977":"6576f6f6"}[chunkId] + ".chunk.js";
};